import type { RootState } from "../store"

export const checkerSelector = (state: RootState) => state.checker
